import { FilterSection } from "@flights/search-ui";
import React from "react";
import { useDurationFilterController } from "./useDurationFilter.controller";
import { InputSlider } from "@bookingcom/bui-react";
import { LayoverDurationFilter } from "../../../../../components/elements/SearchFilters/FiltersSplit/LayoverDurationFilter";
import flights_web_budget_layover_airports_filters from "../../../../../utils/experiments/funnel/flights_web_budget_layover_airports_filters";
import styles from "./DurationFilter.module.css";

export const DurationFilter = () => {
  const {
    isFilterAvailable,
    title,
    showReset,
    resetLabel,
    onClickReset,
    min,
    max,
    value,
    ariaLabel,
    label,
    renderTooltipValue,
    renderValue,
    onChange,
    onChangeCommit,
    keyForRemount
  } = useDurationFilterController();

  if (!isFilterAvailable) return null;

  const addNewFilters = !!flights_web_budget_layover_airports_filters.trackWithDefaultStage();

  return (
    <FilterSection
      attributes={{ "data-testid": "duration_filter" }}
      title={{
        text: title,
        tagName: addNewFilters ? "h3" : "h2",
        attributes: { id: "duration_filter" },
        variant: addNewFilters ? "strong_2" : "emphasized_1"
      }}
      reset={
        showReset && !addNewFilters
          ? {
              text: resetLabel,
              onClick: onClickReset,
              attributes: { "data-testid": "search_filter_duration_reset" }
            }
          : undefined
      }
    >
      <div className={styles.inputSliderWrapper}>
        <InputSlider
          key={keyForRemount}
          min={min}
          max={max}
          value={value}
          name="filters-duration"
          attributes={{ "data-testid": "search_filter_duration_slider" }}
          ariaLabel={ariaLabel}
          label={label}
          onChange={({ value }) => onChange(value)}
          onChangeCommit={({ value }) => onChangeCommit(value)}
          renderTooltipValue={renderTooltipValue}
          ariaValuetext={renderTooltipValue}
          renderValue={(val) => <span data-testid="search_filter_duration_travel_time_label">{renderValue(val)}</span>}
        />
      </div>
      {addNewFilters && <LayoverDurationFilter />}
    </FilterSection>
  );
};
